<template>
  <div v-show="isLoaded" class="mHistory-container" v-observe-visibility="startAnimate">
    <div class="mLeft-col">
      <h2 class="mSection-title" :class="{animate: animate}">Nacida en 1893</h2>
      <p class="mParagraph mText-1" :class="{animate: animate}">Bajo el nombre de Cerveza Cuauhtémoc. <br> 
Inspirada en el último emperador azteca, es una de las 
primeras marcas de la cervecería. 
</p>
<p class="mParagraph mText-2" :class="{animate: animate}">Años más adelante, cambia su nombre a la ya reconocida 
marca <strong class="mHighlight" :class="{onlySafari: isSafari}">INDIO</strong>, cerveza mexicana de sabor inigualable. 

</p>
<p class="mParagraph mText-3" :class="{animate: animate}">Actualmente esta cerveza lager oscura se puede encontrar <br> 
en toda la república mexicana, y en algunas ciudades <br> de Estados Unidos.  </p>
    </div>
    <div class="mRight-col">
      <img class="mImgHistory1" :class="{animate: animate}" :src="history1" alt="Imagen del primer puesto de Cerveza Indio">
      <img class="mImgHistory2" :class="{animate: animate}" :src="history2" alt="Imagen de Trabajadores de Indio en sus inicios">
    </div>
  </div>
</template>

<script>
import history1 from '@/assets/history1.png'
import history2 from '@/assets/history2.png'
import { mapGetters } from "vuex";
import Bowser from "bowser"; 

export default {
  name: "History",
  data() {
    return {
      history1,
      history2,
      animate: false,
      isSafari: false
    };
  },
      computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible){
      if(isVisible){
        this.animate=true
      }
      
    }
  },
  components: {},
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
}
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/History.scss";
</style>
